import { StyledTutorialKeys } from "../TutorialKeys.styled"

export const TutorialDash = () => {
  return (<StyledTutorialKeys>
    <div className="key-definition">
      <div className="key">
          <span className="key-modifier">DOUBLE TAP</span>
          <div className="tutorial-key arrow">←</div>
      </div>
      <div className="key-action">GROUND DASH LEFT</div>
    </div>
    <div className="key-definition">
      <div className="key">
          <span className="key-modifier">DOUBLE TAP</span>
          <div className="tutorial-key arrow">→</div>
      </div>
      <div className="key-action">GROUND DASH RIGHT</div>
    </div>
    <div className="key-definition">
      <div className="key">
          <div className="key-text">JUMP</div>
          <span className="key-modifier">+ DOUBLE TAP</span>
          <div className="tutorial-key arrow">←</div>
      </div>
      <div className="key-action">AIR DASH LEFT</div>
    </div>
    <div className="key-definition">
      <div className="key">
          <div className="key-text">JUMP</div>
          <span className="key-modifier">+ DOUBLE TAP</span>
          <div className="tutorial-key arrow">→</div>
      </div>
      <div className="key-action">AIR DASH RIGHT</div>
    </div>
  </StyledTutorialKeys>)
};